import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../src/components/_globals'
import { LayoutPlugin, ModalPlugin, FormGroupPlugin, FormInputPlugin, FormPlugin, AlertPlugin, SpinnerPlugin, ButtonPlugin, NavbarPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faTimes, faEnvelope, faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTwitter, faYoutube, faFacebook, faGoogle, faPinterest, faApple } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMeta from 'vue-meta'

library.add(
  faInstagram,
  faTwitter,
  faYoutube,
  faFacebook,
  faSpinner,
  faGoogle,
  faPlusSquare,
  faEnvelope,
  faTimes,
  faPinterest,
  faApple
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// Install BootstrapVue
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(SpinnerPlugin)
Vue.use(ButtonPlugin)
Vue.use(NavbarPlugin)
Vue.use(AlertPlugin)
Vue.use(VueMeta)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
